import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { PAGE, SeoPageState, SeoState } from '../seo-state';

export function getReducers(): ActionReducerMap<SeoState> {
  return {
    page: StateUtils.loaderReducer<SeoPageState | null>(PAGE),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<SeoState>> = new InjectionToken<ActionReducerMap<SeoState>>(
  'SeoReducers',
);

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
